import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {MenuItem, InputLabel,Grid,FormControl,Select,Alert, Box, Button, Container, TextField, Typography} from "@mui/material";
import {getValidAccessToken} from "../../utils/tokenUtils";

export const UserRegisterView = () => {

    const apiUrl = process.env.REACT_APP_API_URL;
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        reEnterPassword: '',
        firstName: '',
        lastName: '',
        phoneNumber: '',
        userType:'',
        referralCode: '',
    });

    //const [error, setError] = useState('');
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');
        if (formData.password !== formData.reEnterPassword) {
            setErrorMessage("Passwords don't match.");
            return;
        }


        try {
            const token = await getValidAccessToken();
            const response = await axios.post(`${apiUrl}/signup/`,
            {

                username: formData.username,
                email: formData.email,
                password: formData.password,
                first_name: formData.firstName,
                last_name: formData.lastName || '',
                phone_number: formData.phoneNumber || '',
                user_type:selectedOption || '',
                referral_code: formData.referralCode || '',
            },
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    }
                });

            const { success, message } = response.data;

            if (success) {
                setSuccessMessage('User Created successfully!');
            } else {
                setErrorMessage(message);
            }
        } catch (error) {
            console.error(error.response);
            setErrorMessage(error.response.data.message || 'An error occurred. Please try again.');

            //setError(error.response.data.message || 'Something went wrong. Please try again.');
        }
    };
    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
    };
    return (
        <Container maxWidth="xs">
            <Box sx={{ mt: 1, mb: 1 }}>
                <Typography variant="h4" align="center" gutterBottom>
                    New User Registration
                </Typography>
                {errorMessage && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {errorMessage}
                    </Alert>
                )}
                {successMessage && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                        {successMessage}
                    </Alert>
                )}
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        inputProps={{ style: { fontSize: '14px' } }}
                    />
                    <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        type="email"
                        inputProps={{ style: { fontSize: '14px' } }}
                    />
                    <TextField
                        label="Password"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        type="password"
                        inputProps={{ style: { fontSize: '14px' } }}
                    />
                    <TextField
                        label="Re-enter Password"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="reEnterPassword"
                        value={formData.reEnterPassword}
                        onChange={handleChange}
                        required
                        type="password"
                        inputProps={{ style: { fontSize: '14px' } }}
                    />
                    <TextField
                        label="First Name"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        required
                        inputProps={{ style: { fontSize: '14px' } }}
                    />
                    <TextField
                        label="Last Name"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        inputProps={{ style: { fontSize: '14px' } }}
                    />
                    <TextField
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        type="tel"
                        inputProps={{ style: { fontSize: '14px' } }}
                    />

<Typography variant="h4" align="center" gutterBottom>
                </Typography>

                    <Grid item xs>
                                                <FormControl fullWidth variant="outlined" size="small" >
                                                    <InputLabel>User Type</InputLabel>
                                                    <Select
                                                    sx={{
                                                        '& .MuiSelect-select': {
                                                            fontSize: '16px', // Increase font size for the selected value
                                                        },
                                                    }}
                                                        value={selectedOption}
                                                        onChange={handleSelectChange}
                                                        label="User Type"
                                                    >
                                                            <MenuItem key="admin" value="admin" sx={{ fontSize: '1.0 rem' }}>
                                                            admin
                                                            </MenuItem>
                                                            <MenuItem key="tax_preparer" value="tax_preparer" sx={{ fontSize: '1.0 rem' }}>
                                                            tax_preparer
                                                            </MenuItem>
                                                            <MenuItem key="csr" value="csr" sx={{ fontSize: '1.0 rem' }}>
                                                            csr
                                                            </MenuItem>
                                                            <MenuItem key="e_filer" value="e_filer" sx={{ fontSize: '1.0 rem' }}>
                                                            e_filer
                                                            </MenuItem>
                                                            <MenuItem key="p_filer" value="p_filer" sx={{ fontSize: '1.0 rem' }}>
                                                            p_filer
                                                            </MenuItem>
                                                            <MenuItem key="fbar_filer" value="fbar_filer" sx={{ fontSize: '1.0 rem' }}>
                                                            fbar_filer
                                                            </MenuItem>
                                                       
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="large"
                        type="submit"
                        sx={{ mt: 3 }}
                    >
                        Create Account
                    </Button>
                    
                </form>
            </Box>
        </Container>
    )
}
